import React from 'react';
import { Box, Divider, List, ListSubheader } from '@mui/material';
import NavItem from './NavItem';
import useNavColors from './navColors';
import { useAuth } from '@/context/AuthContext';
import { hasManagementRole } from '@/components/auth';

interface DrawerNavItemsProps {
    isOpen: boolean;
    currentPath: string;
    isMobile: boolean;
    handleToggle: () => void;
}

const BASE_NAV_ITEMS = [
    { label: 'Projects', path: '/projects', icon: 'Apps' },
    // { label: 'Agents', path: '/agents', icon: 'Person' },
    { label: 'Calls', path: '/calls', icon: 'Call' },
];

/** The "New" chip comes off at the start of 2027. */
const NEW_CHIP = Date.now() < Date.parse('2027-01-01T00:00:00Z') ? { label: 'New' } : undefined;

const TEAM_NAV_ITEMS = [{ label: 'Global prompts', path: '/global-prompts', icon: 'Language', chip: NEW_CHIP }];

const DrawerNavItems: React.FC<DrawerNavItemsProps> = ({ isOpen, currentPath, isMobile, handleToggle }) => {
    const navColors = useNavColors();
    const { role } = useAuth();

    const teamItems = hasManagementRole(role) ? TEAM_NAV_ITEMS : [];

    const itemProps = (path: string) => ({
        isOpen,
        isActive: currentPath === path.slice(1),
        onClick: isMobile ? handleToggle : undefined,
    });

    return (
        <Box sx={{ flex: 1 }}>
            <List sx={{ p: 0 }}>
                {BASE_NAV_ITEMS.map((item) => (
                    <NavItem key={item.label} {...item} {...itemProps(item.path)} />
                ))}
                {teamItems.length > 0 && (
                    <>
                        <Divider component="li" sx={{ borderColor: navColors.borderColor, mx: 2, my: 1 }} />
                        {isOpen && (
                            <ListSubheader
                                disableSticky
                                sx={{
                                    backgroundColor: 'transparent',
                                    color: navColors.linkIconColor,
                                    fontSize: '0.6875rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.08em',
                                    lineHeight: 'normal',
                                    pt: 0,
                                    pb: 0.5,
                                }}
                            >
                                TEAM
                            </ListSubheader>
                        )}
                        {teamItems.map(({ label, path, icon, chip }) => (
                            <NavItem key={label} label={label} path={path} icon={icon} {...itemProps(path)} slotProps={{ chip }} />
                        ))}
                    </>
                )}
            </List>
        </Box>
    );
};

export default DrawerNavItems;
